module.exports = __webpack_public_path__ + "static/media/YF07_1.41a4bb67.jpg";